import { X } from "lucide-react";
import { useEffect } from "react";

/** Right-side drawer for plan details. Lightweight, no extra deps. */
export default function SidePanel({ open, onClose, title, accent = "slate", children }) {
  useEffect(() => {
    const onEsc = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onEsc);
    return () => window.removeEventListener("keydown", onEsc);
  }, [onClose]);

  if (!open) return null;
  const accents = {
    slate: "border-l-slate-300",
    amber: "border-l-amber-300",
    rose: "border-l-rose-300",
  };
  return (
    <div className="fixed inset-0 z-50" data-testid="meal-plan-side-panel">
      <div className="absolute inset-0 bg-ink/30 backdrop-blur-[2px]" onClick={onClose} />
      <aside className={`absolute top-0 right-0 h-full w-full sm:w-[640px] bg-white border-l-4 ${accents[accent]} shadow-2xl overflow-y-auto`}>
        <div className="sticky top-0 z-10 flex items-center justify-between px-6 py-4 border-b border-border bg-white">
          <h2 className="font-heading text-xl font-extrabold text-ink">{title}</h2>
          <button onClick={onClose} data-testid="side-panel-close" className="p-2 rounded-full hover:bg-cream-200 text-ink-700">
            <X size={18} />
          </button>
        </div>
        <div className="p-6">{children}</div>
      </aside>
    </div>
  );
}
